export default __webpack_public_path__ + "static/media/home-about-moon.88669575.jpg";